module Meevo.Plugins.Register {
    "use strict";

    export class EmptySection extends Meevo.Plugins.Register.RegisterSectionBase {
        constructor(registerContext: Meevo.Plugins.Register.RegisterContext) {
            super(RegisterSectionTypeEnum.Empty, registerContext, "empty", Register.RegisterSectionCatTypeEnum.Sale);
        }
    }

}